import { getEnquiryTimestampMs, resolveEnquiryTimestamp } from "./enquiry-date";
import type { EnquiryRow } from "./enquiry-helpers";

const LIST_KEYS = ["data", "contacts", "enquiries", "results", "items", "records"];

export const buildEnquiryRequestPayload = (query = "", page = 1, pageSize = 10) => ({
    query,
    page,
    page_size: pageSize,
});

const normalizeEnquiryRow = (row: EnquiryRow): EnquiryRow => {
    const timestamp = resolveEnquiryTimestamp(row as Record<string, unknown>);
    if (timestamp == null) return row;
    return { ...row, timestamp };
};

const sortEnquiriesByDate = (rows: EnquiryRow[]) =>
    [...rows].sort((a, b) => getEnquiryTimestampMs(b.timestamp) - getEnquiryTimestampMs(a.timestamp));

export const normalizeEnquiryList = (payload: unknown): EnquiryRow[] => {
    let rows: EnquiryRow[] = [];

    if (Array.isArray(payload)) rows = payload as EnquiryRow[];
    else if (payload != null && typeof payload === "object") {
        const record = payload as Record<string, unknown>;
        for (const key of LIST_KEYS) {
            const candidate = record[key];
            if (Array.isArray(candidate)) {
                rows = candidate as EnquiryRow[];
                break;
            }
        }
    }

    return sortEnquiriesByDate(rows.map(normalizeEnquiryRow));
};

export const getEnquiryLoadError = (status?: number | null, problem?: string | null) => {
    if (problem === "NETWORK_ERROR" || problem === "CONNECTION_ERROR" || status === 0) {
        return "Could not reach the server. Check your connection and try again.";
    }
    if (status === 401 || status === 403) {
        return "You do not have access to view enquiries.";
    }
    return "Could not load enquiries. Please try again.";
};
